import { _, $, Backbone, Radio, CountryList } from "../../../vendor";
import { Backform, Biscuit, Notification } from "../../utils";
import InboomaBaseView from "../InboomaBaseView";

import OffCanvasBehavior from "../../behaviors/Behavior.OffCanvas";

import Location from "../../models/Location";

/**
 * Gets Latitude and Longitude within an Object
 * @param data {String}
 * @returns {*}
 */
export default InboomaBaseView.extend({
  template: _.noop,

  ui: {
    errorMessageField: ".off-canvas__form-error",
  },

  initialize() {
    this.contingents = Radio.channel("contingents").request("get:data");
    this.render();
  },

  onRender() {
    this.getUI("errorMessageField").addClass("hide");
    // Make contingent-array become ID
    // location < 1:1 > contingent
    let location_id = "";
    let country = null;
    if (this.model.get("id") == "") {
      this.$el
        .find(".inb-page-title")
        .html(this.t("add_${a}", { a: this.t("location") }, "capital"));
      //this.model.set('contingent_id', this.contingents.models[0].get('id'));
    } else {
      this.$el
        .find(".inb-page-title")
        .html(this.t("edit_${a}", { a: this.t("location") }, "capital"));
      //this.model.set('contingent_id', this.model.get('contingents')[0].get('id'));
      location_id = " (ID: " + this.model.get("id") + ")";
      country = this.model.get("location_addres.country");
    }
    let time_rates = [
      { label: this.t("minutes", null, "capital"), value: 60 },
      { label: this.t("hours", null, "capital"), value: 3600 },
      { label: this.t("days", null, "capital"), value: 86400 },
    ];
    let country_list = [
      {
        label: "",
        value: "",
      },
    ];
    let availability_rules_options = [
      { label: this.t("contingents_only", null, "capital"), value: "contingents" },
      {
        label: this.t("contingents_prebooking_blocked", null, "capital"),
        value: "contingents_prebooking_blocked",
      },
      {
        label: this.t("contingents_prebooking_resources", null, "capital"),
        value: "contingents_prebooking_resources",
      },
      {
        label: this.t("contingents_prebooking_request", null, "capital"),
        value: "contingents_prebooking_request",
      },
    ];
    let availability_checkin_options = [
      { label: this.t("reservation-only", null, "capital"), value: "reservation-only" },
      { label: this.t("checkin", null, "capital"), value: "checkin" },
    ];
    const language = Biscuit.get("user.lang").split("_");

    let index_counter = 0;

    _.each(CountryList.getNames(language[0]), (key, val) => {
      country_list.push({
        label: key,
        value: val,
      });

      index_counter++;

      if (country !== null && country != "" && key == country) {
        index = index_counter;
      }
    });

    const that = this;
    let fields = [
      {
        name: "name",
        label: this.t("name", null, "capital") + location_id,
        required: true,
        control: "input",
        size: {
          large: "6",
        },
      },
      {
        name: "description",
        label: this.t("description", null, "capital"),
        control: "input",
        size: {
          large: "6",
        },
        helpMessage: this.t("locations_description_field_info"),
      },
      {
        name: "latitude",
        label: this.t("latitude", null, "capital"),
        required: false,
        control: "input",
        pattern: "number",
        size: {
          large: "4",
        },
      },
      {
        name: "longitude",
        label: this.t("longitude", null, "capital"),
        required: false,
        control: "input",
        pattern: "number",
        size: {
          large: "4",
        },
      },
      {
        name: "geofence",
        label: this.t("geofence", null, "capital"),
        control: "input",
        size: {
          large: "3",
        },
        helpMessage: this.t("radius_in_meter", null, "capital"),
      },
      {
        name: "ssid",
        label: this.t("ssid", null, "capital"),
        control: "input",
        size: {
          large: "12",
        },
        helpMessage: this.t("ssid_of_network", null, "capital"),
      },
    ];
    if (Biscuit.get("client.isBikeSharing") !== "true") {
      fields.push({
        name: "fe_visible",
        label: this.t("fe_visible", null, "capital"),
        control: "boolean",
        size: {
          large: "6",
        },
      });
    }
    if (Biscuit.get("client.isVehicleOwner") === "true") {
      fields.push({
        name: "oneway",
        label: this.t("oneway", null, "capital"),
        control: "boolean",
        size: {
          large: "6",
        },
      });
    }

    fields.push(
      {
        name: "location_addres.organization",
        control: "input",
        label: this.t("organization", null, "capital"),
        required: false,
        size: {
          large: "4",
        },
      },
      {
        name: "location_addres.street",
        control: "input",
        label: this.t("street", null, "capital"),
        required: false,
        size: {
          large: "5",
        },
      },
      {
        name: "location_addres.house_number",
        control: "input",
        label: this.t("house_number", null, "capital"),
        required: false,
        size: {
          large: "3",
        },
      },
      {
        name: "location_addres.country",
        control: "select",
        label: this.t("country", null, "capital"),
        options: country_list,
        required: false,
        size: {
          large: "4",
        },
      },
      {
        name: "location_addres.city",
        control: "input",
        label: this.t("city", null, "capital"),
        required: false,
        size: {
          large: "5",
        },
      },
      {
        name: "location_addres.zip_code",
        control: "input",
        label: this.t("zip_code", null, "capital"),
        required: false,
        size: {
          large: "3",
        },
      },
      {
        name: "location_addres.phone_number",
        control: "input",
        label: this.t("phone_number", null, "capital"),
        required: false,
        size: {
          large: "6",
        },
      },
      {
        name: "location_addres.email",
        control: "input",
        label: this.t("email", null, "capital"),
        required: false,
        size: {
          large: "6",
        },
      },
      {
        name: "_pre_booking_time",
        label: this.t("pre_booking_time", null, "capital"),
        control: "uneditable-input",
        size: {
          large: "12",
        },
      },
      {
        name: "_amount",
        label: this.t("count_units", null, "capital"),
        control: "input",
        size: {
          large: "2",
        },
      },
      {
        name: "_rate",
        label: this.t("units", null, "capital"),
        control: "select",
        options: time_rates,
        size: {
          large: "4",
        },
      },
      {
        name: "_availability_check_options",
        label: this.t("availability_check_options", null, "capital"),
        control: "uneditable-input",
        size: {
          large: "12",
        },
      },
      {
        name: "availability_rules",
        label: this.t("availability_rules", null, "capital"),
        control: "select",
        options: availability_rules_options,
        size: {
          large: "12",
        },
      },
      {
        name: "availability_checkin",
        label: this.t("availability_checkin", null, "capital"),
        control: "select",
        options: availability_checkin_options,
        size: {
          large: "12",
        },
      },
      {
        label: this.t("save"),
        control: "button",
        extraClasses: ["expanded button-submit"],
      },
    );

    const locationsModal = new Foundation.Reveal(this.$el),
      form = new Backform.Form({
        el: that.$el.find(".inb-locations-form__content"),
        model: that.model,
        fields: fields,

        events: {
          submit() {
            return false;
          },

          "click .button-submit"(ev) {
            ev.preventDefault();
            that.$el.find("form .is-invalid-input").removeClass("is-invalid-input");

            $(that.$el.find("form")).foundation("validateForm");

            if (
              typeof that.model != "undefined" &&
              that.model.isValid() &&
              !that.$el.find("form .is-invalid-input").length
            ) {
              that.model = OffCanvasBehavior.prototype.normalizeModel(that.model);
              /*that.model.attributes.contingents = [];
                        that.model.attributes.contingents[0] = {
                          id : that.model.get('contingent_id'),
                          _joinData : {
                            location_id : that.model.get('id'),
                            contingent_id : that.model.get('contingent_id')
                          }
                        };*/

              that.model.set("geofence", parseInt(that.model.get("geofence")));

              if (
                that.model.get("geofence") != 0 &&
                (that.model.get("geofence") == "" || _.isNaN(that.model.get("geofence")))
              ) {
                that.$el.find('input[name="geofence"]').addClass("is-invalid-input");
                that
                  .getUI("errorMessageField")
                  .removeClass("hide")
                  .html(that.t("location_error_geofence_number"))
                  .fadeIn("fast");
                return false;
              }

              that.model.set("pre_booking_time", parseInt(that.model.get("_amount")));

              if (
                that.model.get("pre_booking_time") != 0 &&
                that.model.get("pre_booking_time") != "" &&
                !_.isNaN(that.model.get("pre_booking_time"))
              ) {
                that.model.set(
                  "pre_booking_time",
                  parseInt(that.model.get("_amount")) * parseInt(that.model.get("_rate")),
                );
              }

              that.model.set("client_id", Number(Biscuit.get("user.client_id")));
              that.model.set("longitude", parseFloat(that.model.get("longitude")));
              that.model.set("latitude", parseFloat(that.model.get("latitude")));
              delete that.model.attributes.contingent_id;

              const _contingents = that.model.attributes.contingents;

              // Remove those attributes that may become problematic
              delete that.model.attributes.contingents;
              delete that.model.attributes._locale;
              delete that.model.attributes.networks;
              delete that.model.attributes.check_in_periods;
              delete that.model.attributes.external_location_id;
              delete that.model.attributes._amount;
              delete that.model.attributes._rate;

              that.model.save(null, {
                success(model, response) {
                  model = new Location(model.toJSON());
                  // Re-attach contingents as missing in response
                  // #18586
                  model.set("contingents", _contingents);

                  that.collection.set(model, { add: true, merge: true, remove: false });
                  locationsModal.close();

                  if (that.collection.models.length == 1) {
                    that.collection.trigger("forceRender");
                  }

                  new Notification({
                    message: that.t("saved_${a}", { a: that.t("location") }, "capital"),
                    duration: 5000,
                    type: "success",
                    closeable: true,
                    icon: "fi fi-marker",
                  });
                },
                error(model, response, options) {
                  let message = that.t("request_error");

                  if (typeof response.responseJSON !== "undefined") {
                    const data = response.responseJSON.data;

                    if (typeof data !== "undefined" && typeof data.message !== "undefined") {
                      message = that.t(data.message);
                    }
                  }

                  new Notification({
                    message,
                    duration: 5000,
                    type: "warning",
                    closeable: true,
                    icon: "fi fi-check",
                  });
                  that.getUI("errorMessageField").removeClass("hide").html(message).fadeIn("fast");
                },
              });
            } else {
              if (typeof that.model != "undefined") {
                that
                  .getUI("errorMessageField")
                  .removeClass("hide")
                  .html(that.t("form_validation_error"))
                  .fadeIn("fast");
              }
            }
          },
        },
      }).render();
    $('select[name="availability_rules"]').prop("disabled", true);
    $('select[name="availability_checkin"]').prop("disabled", true);
    new Foundation.Abide(that.$el.find("form"), { liveValidate: true });

    locationsModal.open();

    $(document).on("closed.zf.reveal", () => {
      // @TODO Same bug as his time in offCanvasBehavior
      Backbone.history.navigate("locations", { trigger: true });
      that.remove();
      that.destroy();
      that.unbind();
      delete that.model;
      $(document).off("closed.zf.reveal");
    });
  },
});
